import InputTextarea from './InputTextarea';

export default InputTextarea;
